import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ValidationWorkbenchApiTraceService } from '../services/validation-workbench-debug/validation-workbench-api-trace.service';

export const validationWorkbenchApiTraceInterceptor: HttpInterceptorFn = (req, next) => {
  const trace = inject(ValidationWorkbenchApiTraceService);
  if (!trace.isActive() || !isSgiRequest(req.urlWithParams || req.url)) {
    return next(req);
  }

  const startedAt = typeof performance !== 'undefined' ? performance.now() : Date.now();
  const url = req.urlWithParams || req.url;

  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        trace.recordHttpEvent({
          method: req.method,
          url,
          status: event.status,
          durationMs: elapsed(startedAt),
          requestBody: req.body,
          responseBody: event.body,
        });
      }
    }),
    catchError((err: unknown) => {
      const httpErr = err instanceof HttpErrorResponse ? err : null;
      trace.recordHttpEvent({
        method: req.method,
        url,
        status: httpErr?.status ?? 0,
        durationMs: elapsed(startedAt),
        requestBody: req.body,
        responseBody: httpErr?.error,
        errorMessage: httpErr?.message || 'Request failed',
      });
      return throwError(() => err);
    })
  );
};

function isSgiRequest(url: string): boolean {
  return url.startsWith(environment.SGI_API_URL);
}

function elapsed(startedAt: number): number {
  const now = typeof performance !== 'undefined' ? performance.now() : Date.now();
  return Math.round(now - startedAt);
}
